import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {OfferBadge} from "./offer_badge"

export const offerBadgeLoader = function (options = {}) {
    componentLoader(componentConfig(OfferBadge, OfferBadge.config.componentTypeKey, OfferBadge.config.baseHtmlClass), options);
};

